import Vue from 'vue';
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue';
import VueCompositionAPI from '@vue/composition-api';

import router from './router';
import store from './store';
import App from './App.vue';
import Auth from './auth';
import axios from './http/axios';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const authorization = error.config && error.config.headers && error.config.headers.Authorization;
    if (error.response && error.response.status === 401 && Auth.token && authorization === `Bearer ${Auth.token}`) {
      Auth.logout();
      if (error.config.url !== '/user' && router.currentRoute.name !== 'login') {
        router.replace({ name: 'login' }).catch(() => {});
      }
    }

    return Promise.reject(error);
  },
);

// Global Directives
import './global-directives';

// Global Components
import './global-components';

// Validation
import './vee-validate';

// Loader
import './global-loader';

// 3rd party plugins
import '@/libs/portal-vue';
import '@/libs/toastification';
import '@/libs/sweet-alerts';

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
